import { render, staticRenderFns } from "./JobReferraldetails.vue?vue&type=template&id=0a22c499&scoped=true&"
import script from "./JobReferraldetails.vue?vue&type=script&lang=ts&"
export * from "./JobReferraldetails.vue?vue&type=script&lang=ts&"
import style0 from "./JobReferraldetails.vue?vue&type=style&index=0&id=0a22c499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22c499",
  null
  
)

export default component.exports